import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 blur-[120px] rounded-full" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 blur-[120px] rounded-full" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full relative z-10"
      >
        <div className="text-center mb-12">
          <Link to="/" className="inline-flex items-center space-x-3 group mb-8">
            <div className="bg-white text-slate-950 w-10 h-10 rounded-xl flex items-center justify-center font-black text-lg group-hover:rotate-12 transition-transform">
              dt
            </div>
          </Link>
          <h1 className="text-4xl font-black text-white mb-4 tracking-tighter italic uppercase">{title}</h1>
          <p className="text-slate-400 font-medium">{subtitle}</p>
        </div>

        <div className="bg-white/5 border border-white/10 backdrop-blur-xl p-10 rounded-[2.5rem] shadow-2xl">
          {children}
        </div>
      </motion.div>
    </div>
  );
}